<template>
  <!-- @click="onClickHandler" -->
  <!-- :onmouseover="exitmenu()" -->
  <div @click="onClickHandler">
    <div id="divContainer" class="page-effect" v-on:click="exitmenu">
      <section
        id="sectionId"
        class="body-content round_Table_mainwrap pt-0"
        :style="
          'background-color: #f1f3f4; background-image:url(' +
          eventBGImage +
          ')'
        "
      >
        <div class="rt-wrap round_Table">
          <v-tabs vertical id="tabWrap" class="collapsed" :style="getHeight()">
            <!--<a
              v-show="mySessionsFiltered"
              id="btnListLeftCollapse"
              :class="
                drawer
                  ? 'btn-drawer fa fa-arrow-right'
                  : 'btn-drawer fa fa-arrow-left collapse'
              "
              @click.stop="drawer = !drawer"
            ></a>-->
            <!--<a
              v-show="mySessionsFiltered"
              id="btnListLeftCollapse"
              :class="
                drawerPinned
                  ? 'btn-drawer btn-drawer-pin'
                  : drawer
                  ? 'btn-drawer right-double-arrow'
                  : 'btn-drawer btn-drawer-unpin collapse'
              "
              @click.stop="drawerPinned = !drawerPinned"
            ></a>-->
            <div
              id="rtListLeft"
              :style="'border: 0px; padding:15px; width: ' + tabMinWidth + 'px'"
            >
              <!--<h3
                id="headerText"
                class="page-head text-uppercase"
                style="margin-right: 20px"
              >
                ROUND TABLES
              </h3>-->
              <h3 class="page-head mb-0 mt-3" style="margin-right: 20px">
                Live and Upcoming
              </h3>
              <v-tab
                v-show="false"
                href="#tab"
                @click.stop="tabClicked(0)"
                :class="tabId == 0 ? 'rt-tab-active' : ''"
              >
                <v-icon left> mdi-earth </v-icon>
                {{ openTablesLabel }}
              </v-tab>
              <v-tab
                v-show="false"
                href="#tab"
                @click.stop="tabClicked(1)"
                :class="tabId == 1 ? 'rt-tab-active' : ''"
              >
                <v-icon left> mdi-lock </v-icon>
                {{ privateTablesLabel }}
              </v-tab>
              <h4 v-if="mySessionsFiltered && rtSessions.length > 0">
                Select Session
              </h4>
              <v-tab
                v-show="mySessionsFiltered"
                v-for="session in rtSessions"
                :id="'stab_' + session.SessionId"
                :key="'tab_' + session.SessionId"
                href="#tab"
                @click.stop="
                  tabClicked(
                    2,
                    session.SessionId,
                    session.SessionTypeDetails.RoundTableTopic.TopicId
                  )
                "
                :class="
                  tabId == 2 && sessionId == session.SessionId
                    ? 'rt-tab-active'
                    : ''
                "
              >
                <div class="upcoming-single-event">
                  <div class="event-status">
                    <span
                      :class="
                        session.Status == 1 ? 'green-status' : 'orange-status'
                      "
                      >{{ session.StatusLabel }}</span
                    >
                    <p>
                      {{ session.StartTimeLabel }} - {{ session.EndTimeLabel }}
                    </p>
                  </div>
                  <p class="event-name">{{ session.Name }}</p>
                </div>
              </v-tab>
            </div>
            <v-tab-item value="tab">
              <v-card flat>
                <div
                  class=""
                  :class="
                    isAdminComponent
                      ? 'right-rt-wrap admin-section-wrap'
                      : 'right-rt-wrap'
                  "
                >
                  <v-row>
                    <v-col
                      md="6"
                      class="d-flex justify-content-start align-items-center px-lg-0"
                    >
                      <!--<h3>{{ tabLabel }}</h3>-->
                      <h3
                        id="headerText"
                        class="page-head text-uppercase mt-md-3"
                        style="
                          margin-right: 20px;
                          overflow: hidden;
                          text-overflow: ellipsis;
                          white-space: nowrap;
                          line-height: 1em;
                        "
                      >
                        <span v-show="tabId == 3" class="pr-2">
                          <router-link
                            id="anchExh"
                            to="/exhibitorsview"
                            data-tag="sponsorsListBAck"
                          >
                            <!-- <a href="#" id="anchExh" v-on:click.prevent="goBack"> -->
                            <svg
                              version="1.1"
                              id="Capa_1"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlns:xlink="http://www.w3.org/1999/xlink"
                              x="0px"
                              y="0px"
                              fill="#242432"
                              width="24px"
                              height="24px"
                              viewBox="0 0 31.494 31.494"
                              style="enable-background: new 0 0 31.494 31.494"
                              xml:space="preserve"
                            >
                              <path
                                style="fill: #1e201d"
                                d="M10.273,5.009c0.444-0.444,1.143-0.444,1.587,0c0.429,0.429,0.429,1.143,0,1.571l-8.047,8.047h26.554 c0.619,0,1.127,0.492,1.127,1.111c0,0.619-0.508,1.127-1.127,1.127H3.813l8.047,8.032c0.429,0.444,0.429,1.159,0,1.587 c-0.444,0.444-1.143,0.444-1.587,0l-9.952-9.952c-0.429-0.429-0.429-1.143,0-1.571L10.273,5.009z"
                              />
                              <g />
                              <g />
                              <g />
                              <g />
                              <g />
                              <g />
                              <g />
                              <g />
                              <g />
                              <g />
                              <g />
                              <g />
                              <g />
                              <g />
                              <g />
                            </svg>
                            <!-- </a> -->
                          </router-link>
                        </span>
                        <v-tooltip v-if="tabId == 3" top>
                          <template v-slot:activator="{ on }">
                            <span v-on="on">
                              {{ headerText + " - " + exhibitorName }}
                            </span>
                          </template>
                          <span class="v-tooltip-content v-tooltip-top">
                            {{ headerText + " - " + exhibitorName }}
                          </span>
                        </v-tooltip>
                        <span v-else>
                          {{ headerText }}
                        </span>
                      </h3>
                      <!--                
                      v-show="rtSettings.ShowFilter && rtGroups.length > 2"
                      -->
                      <v-menu
                        open-on-hover
                        offset-y
                        min-width="200"
                        :class="
                          rtSettings.ShowFilter && rtGroups.length > 2
                            ? ''
                            : 'invisible'
                        "
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <div
                            :class="
                              rtSettings.ShowFilter && rtGroups.length > 2
                                ? 'pl-3'
                                : 'pl-3 invisible'
                            "
                          >
                            <v-btn
                              tile
                              text
                              outlined
                              v-bind="attrs"
                              v-on="on"
                              :class="
                                rtGroupId
                                  ? 'btn-filter has-filter'
                                  : 'btn-filter'
                              "
                              ><v-icon left>filter_list</v-icon
                              >{{ $t("attendee.filter") }}</v-btn
                            >
                          </div>
                        </template>
                        <v-list>
                          <v-list-item-group
                            active-class="pink--text custom-radio"
                          >
                            <template v-for="item in rtGroups">
                              <v-list-item
                                :key="item.TopicId"
                                @click="filterByGroup(item.TopicId)"
                                style="min-height: 24px"
                                :class="
                                  rtGroupId == item.TopicId
                                    ? 'v-list-item--active'
                                    : ''
                                "
                              >
                                <v-list-item-content
                                  :class="
                                    rtGroupId == item.TopicId
                                      ? 'v-list-item--active'
                                      : ''
                                  "
                                  style="cursor: pointer; padding: 4px 0"
                                  >{{ item.TopicName
                                  }}<!--<label
                              ><span class="radios"
                                ><img
                                  src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/242518/check-icn.svg"
                                  alt="Checked Icon" /></span
                              ></label
                            >-->
                                </v-list-item-content>
                              </v-list-item>
                            </template></v-list-item-group
                          ></v-list
                        ></v-menu
                      >
                    </v-col>
                    <!-- <div class="d-block d-md-none">
                      <button
                        class="mob_search_button"
                        v-on:click="mob_rlist_search()"
                      >
                        <img
                          src="../assets/Images/icons/search-black.svg"
                          alt="e2m"
                          width="20px"
                        />
                      </button>
                    </div> -->
                    <v-col
                      v-if="rtSettings.ShowSearch"
                      md="6"
                      style="flex-direction: row-reverse; position: relative"
                      class="right-search-hld px-lg-0"
                      id="mob_r_search"
                    >
                      <!--<v-icon left>mdi-magnify</v-icon>-->
                      <a href="javascript:void(0);" @click="onTextSearch">GO</a>
                      <div class="position-relative s_inner_w">
                        <v-text-field
                          hide-details
                          label="Search by table name"
                          background-color="white"
                          style="
                            border: 1px solid #cecedf;
                            border-radius: 4px 0 0 4px;
                            max-width: 300px;
                            position: relative;
                          "
                          solo
                          flat
                          v-model="searchText"
                        >
                        </v-text-field>
                        <div class="reset-search-btn">
                          <p v-if="searchText" @click="searchText = ''">
                            <v-icon dark small color="#8a8a8a"
                              >mdi-close</v-icon
                            >
                          </p>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row v-if="showTab">
                    <v-col md="12" cols="12">
                      <div class="round-table-filter-tab">
                        <span
                          v-if="openTableCount > 0"
                          :class="tabId == 0 ? 'active-tab' : ''"
                          @click.stop="tabClicked(0)"
                        >
                          Open
                        </span>
                        <span
                          v-if="privateTableCount > 0"
                          :class="tabId == 1 ? 'active-tab' : ''"
                          @click.stop="tabClicked(1)"
                        >
                          Private
                        </span>
                        <span
                          v-if="mySessionsFiltered && rtSessions.length > 0"
                          :class="tabId == 2 ? 'active-tab' : ''"
                          @click.stop="
                            tabClicked(
                              2,
                              rtSessions[0].SessionId,
                              rtSessions[0].SessionTypeDetails.RoundTableTopic
                                .TopicId
                            )
                          "
                        >
                          Sessions
                        </span>
                        <span
                          v-if="exhibitorsLoaded && rtExhibitors.length > 0"
                          :class="tabId == 3 ? 'active-tab' : ''"
                          @click.stop="
                            tabClicked(
                              3,
                              rtExhibitors[0].ExhibitorId,
                              rtExhibitors[0].RoundTableTopic.TopicId,
                              rtExhibitors[0].ExhibitorName
                            )
                          "
                        >
                          Exhibitors
                        </span>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row
                    v-if="
                      tabId == 2 &&
                      (!rtSettings.ShowSessionList ||
                        liveSessionCount + upcomingSessionCount < 2) &&
                      currentSession
                    "
                  >
                    <v-col md="12" cols="12" class="p-0">
                      <h4 class="mb-0 mt-0">{{ currentSession.Name }}</h4>
                      <p class="time">
                        {{ currentSession.StartTimeLabel }} -
                        {{ currentSession.EndTimeLabel }}
                      </p>
                    </v-col>
                  </v-row>
                  <div
                    v-if="!rtLoading && currentRoundTables.length == 0"
                    class="d-flex flex-column justify-content-center align-items-center mt-12 noTableMessage"
                  >
                    <img src="../assets/Images/roundtable.png" />
                    <h3>{{ noTableMessage }}</h3>
                  </div>
                  <v-row
                    id="rtGrid"
                    :class="
                      isAdminComponent
                        ? 'm-md-0 m-2 mt-5'
                        : 'rt-grid m-md-0 m-2 mt-5'
                    "
                  >
                    <div
                      v-show="rtLoading"
                      id="divLoading"
                      style="
                        margin: 0px;
                        padding: 0px;
                        position: absolute;
                        right: 0px;
                        top: 50%;
                        width: 100%;
                        height: 100%;
                        z-index: 30001;
                        opacity: 1;
                        transform: translateY(-50%) scale(2);
                      "
                    >
                      <div class="loader">
                        <v-progress-circular
                          size="30"
                          indeterminate
                          color="primary"
                        ></v-progress-circular>
                      </div>
                    </div>
                    <!--add roundtable start--->
                    <!-- <div class="add-rt-box">
                      <div class="attendee-box-hld  f-center ss-add-plus-box">
                        <a data-toggle="modal" data-target="#add-rt">
                        <img src="../assets/Images/icons/add-new-blue.svg" alt="e2m" />
                        <h3>
                          Add Roundtable 
                        </h3>
                        </a>
                        
                      </div>
                    </div> -->
                    <!---add roundtable end-->
                    <RoundTable
                      v-for="table in currentRoundTables"
                      :key="'rt_' + table.TableId"
                      pageId="rt"
                      :isAdminComponent="isAdminComponent"
                      :table="table"
                      @JoinRT="JoinRT"
                      @OpenAddRTPopup="OpenAddRTPopup"
                      @changeTableStatus="changeTableStatus"
                      @deleteTable="requestConfirmDeleteTable"
                      :style="isAdminComponent ? '' : 'height: 250px'"
                      :class="
                        isAdminComponent ? 'rt-self-service col-md-12' : ''
                      "
                    >
                    </RoundTable>
                    <!--<div
                      v-for="table in currentRoundTables"
                      :id="'table_' + table.TableId"
                      :key="'table_' + table.TableId"
                      class="single-rt"
                    >
                      <div class="single-new-rt">
                        <div class="rt-head">
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <h5 v-on="on">{{ table.TableName }}</h5>
                            </template>
                            <span class="v-tooltip-content v-tooltip-top">{{
                              table.TableName
                            }}</span>
                          </v-tooltip>
                          <p v-if="table.Occupied == 0">Be the first to join</p>
                          <p v-else-if="table.Capacity - table.Occupied == 0">
                            <v-icon left> mdi-sofa-single </v-icon>No Slots Available
                          </p>
                          <p v-else-if="table.Capacity - table.Occupied == 1">
                            <v-icon left> mdi-sofa-single </v-icon>1 Slot Available
                          </p>
                          <p v-else>
                            <v-icon left> mdi-sofa-single </v-icon
                            >{{ table.Capacity - table.Occupied }} Slot(s) Available
                          </p>
                        </div>
                        <div
                          :class="'rt-md ' + table.JoinButtonClass"
                          @click="JoinRT(table.TableId, sessionId)"
                        >
                          <v-img
                            src="../assets/Images/rt-seat.jpg"
                            max-width="140px"
                            max-height="140px"
                          ></v-img>
                          <div class="rt-company-logo">
                            <v-img
                              v-if="table.RoundtableLogo"
                              :src="getCDNUrl(table.RoundtableLogo)"
                            ></v-img>
                            <v-img v-else src="../assets/Images/rt-logo.png"></v-img>
                          </div>
                        </div>
                        <div class="rt-bt" @click="JoinRT(table.TableId, sessionId)">
                          <a
                            href="javascript:void(0);"
                            :class="table.JoinButtonClass"
                            >{{ table.JoinButtonLabel }}</a
                          >
                        </div>
                      </div>
                    </div>-->
                  </v-row>
                </div>
              </v-card>
            </v-tab-item>
          </v-tabs>

          <div
            id="RetryJoinInZoom"
            class="modal fade"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div class="modal-dialog" role="document" style="max-width: 400px">
              <div class="modal-content">
                <div class="modal-body">
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18.03"
                      height="18.031"
                      viewBox="0 0 18.03 18.031"
                    >
                      <path
                        id="close.svg"
                        fill="#242432"
                        d="M1422.25,525.005l7.51,7.508a0.885,0.885,0,0,1,0,1.243,0.876,0.876,0,0,1-1.24,0l-7.51-7.508-7.51,7.508a0.876,0.876,0,0,1-1.24,0,0.867,0.867,0,0,1,0-1.243l7.51-7.508-7.51-7.507a0.878,0.878,0,0,1,1.24-1.243l7.51,7.508,7.51-7.508a0.874,0.874,0,0,1,1.24,0,0.885,0.885,0,0,1,0,1.243Z"
                        transform="translate(-1412 -516)"
                      />
                    </svg>
                  </button>

                  <div class="retry-modal p-4">
                    <p
                      style="font-size: 20px; font-weight: 600; color: #1e1f26"
                    >
                      Please try again.
                    </p>
                    <div>
                      <a
                        href="javascript:void(0)"
                        class="button-no"
                        @click="cancelRetryJoinInZoom"
                        >Cancel</a
                      >
                      <a
                        href="javascript:void(0)"
                        class="button-yes"
                        @click="retryJoinInZoom"
                        >Retry</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

    <v-dialog v-model="showDeleteConfirmDialog" max-width="500px" hide-overlay>
      <v-card>
        <v-card-title>
          <div
            class="restore-default-head d-flex justify-content-end align-items-start"
          >
            <v-btn
              text
              fab
              color="#1c1d26"
              height="30px"
              width="30px"
              @click="showDeleteConfirmDialog = false"
              ><v-icon color="#1c1d26" size="25px">mdi-close</v-icon></v-btn
            >
          </div>
          <div
            class="confirmation-option-button pb-10 final-button d-flex justify-content-center align-items-center flex-column"
          >
            <h5>Are you sure you want to delete this session?</h5>
            <div class="mt-5">
              <v-btn
                dark
                large
                color="#1c1d26"
                width="120px"
                class="mr-2"
                @click="onConfirmDeleteTable"
                >Yes</v-btn
              >
              <v-btn
                large
                color="#1c1d26"
                outlined
                width="120px"
                @click="showDeleteConfirmDialog = false"
                >No</v-btn
              >
            </div>
          </div>
        </v-card-title>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import router from "../router";
import db from "../components/firebaseInit";
import APIs from "../components/APIInit";
import RoundTable from "@/components/RoundTable.vue";
import axios from "axios";
import store from "../store";
import common from "@/common";
import jQuery from "jquery";
let $ = jQuery;
import { bus } from "@/main";

let vm;
let sessionStatusRefreshTimer;
export default {
  components: {
    RoundTable,
  },
  props: {
    isAdminComponent: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      rtLoading: true,
      drawer: true,
      drawerPinned: false,
      clientId: this.$store.getters.getClient[0].id,
      eventId: this.$store.getters.getEvent,
      uid: "",
      email: "",
      name: "",
      firstName: "",
      lastName: "",
      company: "",
      phone: "",
      title: "",
      profilepic: "",
      eventName: "",
      event_collectionName: "",
      rtSettings: {
        ShowFilter: false,
        ShowSearch: false,
        ShowSessionList: true,
        HostLegend: this.$t("livestage.host"),
        SeatGrabText: this.$t("livestage.grabseat"),
        AudienceViewText: this.$t("livestage.spectate"),
        TableFullText: this.$t("livestage.tablefull"),
        DisplayLeftPanel: true,
      },
      AgoraPlayerBrowserSupportInMobile: false,
      AgoraPlayerBrowserSupportInIPad: false,
      openTablesLabel: "Open Tables",
      privateTablesLabel: "Private Tables",
      liveAndUpcomingSessions: "Live and Upcoming Sessions",
      noTableMessage: "There are no tables to display",
      tabId: 0,
      tabLabel: "Round Tables",
      entityType: "",
      entityName: "",
      sessionId: "",
      exhibitorId: "",
      exhibitorName: "",
      rtGroupId: "",
      sessionRTGroupId: "",
      exhibitorRTGroupId: "",
      searchText: "",
      filterDisplayState: false,
      rtGroups: [],
      rtSessions: [],
      rtExhibitors: [],
      mySessions: [],
      sessionRTGroupIDs: [],
      allRoundTables: [],
      openTableCount: 0,
      privateTableCount: 0,
      liveSessionCount: 0,
      upcomingSessionCount: 0,
      openAndPrivateTablesChecked: false,
      sessionSettingsLoaded: false,
      sessionsLoaded: false,
      exhibitorsLoaded: false,
      mySessionsLoaded: false,
      mySessionsFiltered: false,
      AgendaFilterOption: 0, // 0: FullAgendaOnly (Default), 1: MyAgendaOnly, 2: ShowAll
      AllowAddRemoveMyAgenda: false,
      RestrictedZoomMeetingEnabled: true,
      tempTable: null,
      zoomErrorMsg:
        "An error has occurred with this Zoom live panel session. Please try again in sometime.",
      eventBGImage: "",
      headerText: "ROUND TABLES",
      textColor: "black",
      e6: 1,
      rtPageURL: "/roundtable",
      LiveStageURL: "/livestage",
      showDeleteConfirmDialog: false,
      selectedTableId: "",
    };
  },
  computed: {
    innerWidth() {
      return window.innerWidth;
    },
    tabMinWidth() {
      //if (vm.rtSessions.length > 0) {
      //  return 430;
      //} else {
      //  return 240;
      //}
      return 330;
    },
    showTab() {
      var tabCount = 0;
      if (vm.openTableCount > 0) {
        tabCount++;
      }
      if (vm.privateTableCount > 0) {
        tabCount++;
      }
      if (vm.mySessionsFiltered && vm.rtSessions.length > 0) {
        tabCount++;
      }
      if (vm.openAndPrivateTablesChecked) {
        if (
          vm.tabId == 0 &&
          vm.openTableCount == 0 &&
          vm.privateTableCount > 0
        ) {
          vm.tabClicked(1);
        } else if (
          vm.tabId == 0 &&
          vm.openTableCount == 0 &&
          vm.privateTableCount == 0 &&
          vm.mySessionsFiltered &&
          vm.rtSessions.length > 0 &&
          vm.rtSessions[0].SessionTypeDetails &&
          vm.rtSessions[0].SessionTypeDetails.RoundTableTopic &&
          vm.rtSessions[0].SessionTypeDetails.RoundTableTopic.TopicId
        ) {
          vm.tabClicked(
            2,
            vm.rtSessions[0].SessionId,
            vm.rtSessions[0].SessionTypeDetails.RoundTableTopic.TopicId
          );
        } else if (
          vm.tabId == 0 &&
          vm.openTableCount == 0 &&
          vm.privateTableCount == 0 &&
          vm.mySessionsFiltered &&
          vm.rtSessions.length == 0 &&
          vm.exhibitorsLoaded &&
          vm.rtExhibitors.length > 0 &&
          vm.rtExhibitors[0].ExhibitorId &&
          vm.rtExhibitors[0].RoundTableTopic &&
          vm.rtExhibitors[0].RoundTableTopic.TopicId &&
          vm.rtExhibitors[0].ExhibitorName
        ) {
          vm.tabClicked(
            3,
            vm.rtExhibitors[0].ExhibitorId,
            vm.rtExhibitors[0].RoundTableTopic.TopicId,
            vm.rtExhibitors[0].ExhibitorName
          );
        }
      }
      return tabCount > 1;
    },
    currentRoundTables() {
      let tables = [];
      let textToSearch = vm.searchText.toLowerCase().trim();
      if (vm.tabId == 3) {
        if (vm.exhibitorRTGroupId) {
          tables = vm.allRoundTables.filter(function () {
            return true;
          });
          if (textToSearch) {
            tables = tables.filter(function (item) {
              return item.TableName.toLowerCase().includes(textToSearch);
            });
          }
        }
      } else if (vm.tabId == 2) {
        if (vm.sessionRTGroupId) {
          tables = vm.allRoundTables.filter(function () {
            return true;
          });
          if (textToSearch) {
            tables = tables.filter(function (item) {
              return item.TableName.toLowerCase().includes(textToSearch);
            });
          }
        }
      } else if (vm.rtGroupId) {
        tables = vm.allRoundTables.filter(function (item) {
          return item.Topic.TopicId == vm.rtGroupId;
        });
        if (textToSearch) {
          tables = tables.filter(function (item) {
            return item.TableName.toLowerCase().includes(textToSearch);
          });
        }
      } else {
        if (textToSearch) {
          tables = vm.allRoundTables.filter(function (item) {
            return item.TableName.toLowerCase().includes(textToSearch);
          });
        } else {
          tables = vm.allRoundTables.filter(function () {
            return true;
          });
        }
      }
      tables = tables.sort(function (a, b) {
        let v1 = a.TableName.toLowerCase().trim();
        let v2 = b.TableName.toLowerCase().trim();
        return v1 < v2 ? -1 : v1 > v2 ? 1 : 0;
      });
      if (vm.allRoundTables.length == 0) {
        vm.noTableMessage = "There are no tables to display";
      } else if (tables.length == 0) {
        vm.noTableMessage = "No Tables found";
      }
      return tables;
    },
    currentSession() {
      var result = null;
      if (vm.tabId == 2 && vm.rtSessions.length > 0 && vm.sessionId) {
        var sessions = vm.rtSessions.filter(function (item) {
          return item.SessionId == vm.sessionId;
        });
        if (sessions.length > 0) {
          result = sessions[0];
        }
      }
      return result;
    },
  },
  watch: {
    drawer(val) {
      if (val) {
        $("#tabWrap").addClass("collapsed");
      } else {
        $("#tabWrap").removeClass("collapsed");
      }
      setTimeout(() => {
        vm.calculateRTColumlCount();
      }, 500);
      setTimeout(() => {
        vm.calculateRTColumlCount();
      }, 1000);
    },
    drawerPinned(val) {
      //alert(val);
      if (val) {
        $("#tabWrap").addClass("pinned");
      } else {
        $("#tabWrap").removeClass("pinned");
      }
      setTimeout(() => {
        vm.calculateRTColumlCount();
      }, 100);
      setTimeout(() => {
        vm.calculateRTColumlCount();
      }, 1000);
      vm.setCookie("rtLeftPanelPinned", val);
    },
    tabId() {
      //if (val == 0) {
      //  vm.tabLabel = vm.openTablesLabel;
      //} else if (val == 1) {
      //  vm.tabLabel = vm.privateTablesLabel;
      //} else if (val == 2) {
      //  vm.tabLabel = vm.liveAndUpcomingSessions;
      //}
      //vm.setCookie("rtLeftPanelTabId", val);
    },
    sessionSettingsLoaded() {
      //alert(
      //  "sessionSettingsLoaded: sessionsLoaded=" +
      //    vm.sessionsLoaded +
      //    "; mySessionsLoaded=" +
      //    vm.mySessionsLoaded
      //);
      if (vm.mySessionsLoaded && vm.sessionsLoaded) {
        vm.filterMySession();
      }
    },
    mySessionsLoaded() {
      //alert(
      //  "mySessionsLoaded: sessionsLoaded=" +
      //    vm.sessionsLoaded +
      //    "; sessionSettingsLoaded=" +
      //    vm.sessionSettingsLoaded
      //);
      if (vm.sessionSettingsLoaded && vm.sessionsLoaded) {
        vm.filterMySession();
      }
    },
    sessionsLoaded() {
      //alert(
      //  "sessionsLoaded: mySessionsLoaded=" +
      //    vm.mySessionsLoaded +
      //    "; sessionSettingsLoaded=" +
      //    vm.sessionSettingsLoaded
      //);
      if (vm.mySessionsLoaded && vm.sessionSettingsLoaded) {
        vm.filterMySession();
      }
    },
    mySessionsFiltered() {
      setTimeout(() => {
        vm.calculateRTColumlCount();
      }, 200);
    },
    //  sessionId: {
    //    handler(newTxData, oldTxData) {
    //      console.log(newTxData);
    //    },
    //  },
  },
  beforeCreate() {
    //alert("beforeCreate");
  },
  created() {
    vm = this;
    if (vm.isAdminComponent) {
      vm.rtPageURL = "/admin-roundtable";
    }
    //let isPinned = vm.getCookie("rtLeftPanelPinned");
    //if (isPinned == "true") {
    //  vm.drawerPinned = true;
    //  vm.drawer = false;
    //} else {
    //  vm.drawerPinned = false;
    //}
    if (vm.$route.params.tid) {
      vm.drawerPinned = true;
      if (vm.$route.params.type) {
        vm.entityType = vm.$route.params.type;
      }
      if (vm.$route.params.name) {
        vm.entityName = vm.$route.params.name;
      }
      if (vm.entityType) {
        vm.exhibitorId = vm.$route.params.tid;
        vm.tabId = 3;
      } else {
        vm.sessionId = vm.$route.params.tid;
        vm.tabId = 2;
      }
    } else {
      //let tabId = vm.getCookie("rtLeftPanelTabId");
      //if (tabId) {
      //  tabId = parseInt(tabId);
      //  if (isNaN(tabId) || tabId == 2) {
      //    vm.tabId = 0;
      //  } else {
      //    vm.tabId = parseInt(tabId);
      //  }
      //} else {
      //  vm.tabId = 0;
      //}
    }
    var obj = JSON.parse(window.localStorage.getItem("my-app"));
    if (obj) {
      vm.eventName = obj.eventname;
      vm.event_collectionName = obj.eventcollectionname;
      vm.AgoraPlayerBrowserSupportInMobile =
        obj.AgoraPlayerBrowserSupportInMobile;
      vm.AgoraPlayerBrowserSupportInIPad = obj.AgoraPlayerBrowserSupportInIPad;
      if (obj.user && obj.user.length > 0) {
        vm.uid = obj.user[0].id;
        vm.email = obj.user[0].Email;
        vm.name = obj.user[0].name;
        vm.firstName = obj.user[0].fname;
        vm.lastName = obj.user[0].lname;
        vm.company = obj.user[0].company;
        vm.phone = obj.user[0].phone;
        vm.title = obj.user[0].title;
        vm.profilepic = obj.user[0].profilepic;
      }

      if (obj.branding && obj.branding.length > 0 && obj.branding[0].favicon) {
        var link =
          document.querySelector("link[rel*='icon']") ||
          document.createElement("link");
        link.type = "image/x-icon";
        link.rel = "shortcut icon";
        link.href = obj.branding[0].favicon;
        document.getElementsByTagName("head")[0].appendChild(link);
      }

      if (obj.EventBranding && obj.EventBranding.length > 0) {
        if (obj.EventBranding[0].topBar) {
          $("#divBannerTop").css(
            "background-color",
            obj.EventBranding[0].topBar
          );
        }
        if (obj.EventBranding[0].eventBGImage) {
          if (!vm.isAdminComponent) {
            vm.eventBGImage = vm.getCDNUrl(obj.EventBranding[0].eventBGImage);
          }
        }
      }
    }
    // common.toggleTopMenu(true);
    // common.toggleLeftMenu(true);
    //$("#topmenu").show();
    //$("#leftmenu").show();
    vm.loadPageTitle();
    vm.loadSessionSettings();
    vm.loadRTSettings();
    vm.loadSessionRTGroups();
    vm.loadRTSessions();
    //if (vm.tabId == 3) {
    vm.loadExhibitors();
    //}
    //vm.rtLoading = false;
  },
  beforeDestroy() {
    if (sessionStatusRefreshTimer) {
      clearInterval(sessionStatusRefreshTimer);
    }
    vm.disposeRoundTableListener();
  },
  mounted() {
    //vm.loadRoundTables();
    if (sessionStatusRefreshTimer) {
      clearInterval(sessionStatusRefreshTimer);
    }
    sessionStatusRefreshTimer = setInterval(function () {
      if (vm.rtSessions.length > 0) {
        vm.changeSessionStatusWithTime();
      }
    }, 2000);
    vm.calculateRTColumlCount();
    //setTimeout(() => {
    //  vm.calculateRTColumlCount();
    //}, 5000);
    $(window).resize(function () {
      vm.calculateRTColumlCount();
    });

    $("#tabWrap [role='tablist']").mouseover(function () {
      if (!vm.drawerPinned) {
        vm.drawer = false;
      }
    });
    $("#tabWrap [role='tablist']").mouseleave(function () {
      if (!vm.drawerPinned) {
        vm.drawer = true;
      }
    });

    let pin = document.createElement("a");
    pin.setAttribute("id", "btnListLeftCollapse1");
    pin.setAttribute("class", "unclps-btn d-none");

    pin.addEventListener("click", function () {
      vm.drawerPinned = !vm.drawerPinned;
      if (vm.drawerPinned && vm.drawer) {
        //vm.drawer = false;
      }
      if (vm.drawerPinned) {
        vm.drawer = false;
      } else {
        vm.drawer = true;
      }
      //e.stopPropagation();
    });
    pin.addEventListener("mouseover", function (e) {
      //vm.drawerPinned = !vm.drawerPinned;
      //if (vm.drawer) {
      //  vm.drawer = false;
      //}
      e.stopPropagation();
    });
    $("#tabWrap [role='tablist']").prepend(pin);

    // var obj = JSON.parse(window.localStorage.getItem("my-app"));
    // try {
    //   var brandingData = await vm.getBrandingJSONDetails(
    //     obj.eventcollectionname + "/Branding/Branding.json"
    //   );
    //   debugger;
    //   if (brandingData.data != undefined) {
    //     if (brandingData.data.EventInfo != undefined) {
    //       if (brandingData.data.EventInfo.BodyTextColor != undefined) {
    //         vm.textColor = brandingData.data.EventInfo.BodyTextColor;
    //       } else {
    //         vm.textColor = "black";
    //       }
    //     } else {
    //       vm.textColor = "black";
    //     }
    //     console.log("BodyTextColor :- " + vm.textColor);
    //     $("#headerText").css("color", vm.textColor);
    //     $("#subHeaderText").css("color", vm.textColor);
    //     $(":root").css("  ", vm.textColor);
    //     $(":root").css("--event-tab-color", vm.textColor);
    //     $(":root").css("--event-active-tab-color", vm.textColor);
    //   }
    // } catch (e) {
    //   console.log("Error in Branding Json Fetch--", e);
    // }
    axios
      .get(store.getters.getBrandingJsonUrl)
      .then(function (brandingData) {
        vm.textColor = brandingData.data.EventInfo.BodyTextColor;
        if (!vm.isAdminComponent) {
          $("#headerText").css("color", vm.textColor);
        }
        //$("#subHeaderText").css("color", vm.textColor);
        $(":root").css("--event-body-text-color", vm.textColor);
        $(":root").css("--event-tab-color", vm.textColor);
        $(":root").css("--event-active-tab-color", vm.textColor);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  methods: {
    OnAddRTSuccess() {
      //
    },
    OnUpdateRTSuccess() {
      //
    },
    onChangeRTStatusSuccess(tableId, isPublished, success) {
      var msg = "";
      if (success) {
        msg = "Round Table " + (isPublished ? "Published" : "Unpublished");
        vm.showSnackbar(msg, "info", "top");
      } else {
        msg = "Round Table Not " + (isPublished ? "Published" : "Unpublished");
        vm.showSnackbar(msg, "error", "top");
      }
      for (var i = 0; i < vm.allRoundTables.length; i++) {
        if (vm.allRoundTables[i].TableId == tableId) {
          if (!success) {
            vm.allRoundTables[i].IsPublished =
              !vm.allRoundTables[i].IsPublished;
          }
          vm.allRoundTables[i].IsStatusChanging = false;
          vm.loadRoundTables();
          break;
        }
      }
    },
    onClickHandler(event) {
      console.log(event);
      //this.rtmpDialog.state = true;
      // event.target is the clicked element object
      //vm.AddAnalitics(event, "click");
    },
    exitmenu: function () {
      $(".tab-content-one .tab-pane").removeClass("active");
      $(".nav-link.tab-link").removeClass("active");
    },
    loadPageTitle() {
      db.collection(vm.event_collectionName)
        .doc("Menu")
        .get()
        .then((doc) => {
          var data = doc.data();
          data.AllMenu.forEach(function (value) {
            if (value.GroupID != 99) {
              if (value.MenuID == 1004) {
                if (vm.$store.state.locale == "English") {
                  vm.headerText = value.DisplayLabel;
                } else if (vm.$store.state.locale == "German") {
                  vm.headerText = value.DisplayLabel_de;
                } else if (vm.$store.state.locale == "French") {
                  vm.headerText = value.DisplayLabel_fr;
                } else if (vm.$store.state.locale == "Chinese") {
                  vm.headerText = value.DisplayLabel_zh;
                } else if (self.$store.state.locale == "Spanish") {
                  vm.headerText = value.DisplayLabel_es;
                } else {
                  vm.headerText = value.DisplayLabel;
                }
                document.title = vm.headerText + " - " + vm.eventName;
                //document.getElementById("headerText").innerText = vm.headerText;
              }
              if (value.MenuID == 1022) {
                vm.LiveStageURL = value.PageUrl ? value.PageUrl : "/livestage";
              }
            }
          });
          data.LeftMenu.forEach(function (value) {
            if (value.GroupID != 99) {
              if (value.MenuID == 1004) {
                if (vm.$store.state.locale == "English") {
                  vm.headerText = value.DisplayLabel;
                } else if (vm.$store.state.locale == "German") {
                  vm.headerText = value.DisplayLabel_de;
                } else if (vm.$store.state.locale == "French") {
                  vm.headerText = value.DisplayLabel_fr;
                } else if (vm.$store.state.locale == "Chinese") {
                  vm.headerText = value.DisplayLabel_zh;
                } else if (self.$store.state.locale == "Spanish") {
                  vm.headerText = value.DisplayLabel_es;
                } else {
                  vm.headerText = value.DisplayLabel;
                }
                document.title = vm.headerText + " - " + vm.eventName;
                //document.getElementById("headerText").innerText = vm.headerText;
              }
              if (value.MenuID == 1022) {
                vm.LiveStageURL = value.PageUrl ? value.PageUrl : "/livestage";
              }
            }
          });
        });
    },
    getHeight() {
      return common.getHeaderHeight();
    },
    calculateRTColumlCount() {
      let cols = 3;
      let rtWidth = "185px";
      let rtMinWidth = 185;
      //alert(window.innerWidth);
      let windowWidth = window.innerWidth;
      if (!windowWidth) {
        windowWidth = 1024;
      }
      //alert(windowWidth);
      let leftPanelWidth = $("#rtListLeft").width();
      if (!leftPanelWidth) {
        leftPanelWidth = 0;
      }
      let leftMenuWidth = $("#leftmenu").width();
      if (!leftMenuWidth) {
        leftMenuWidth = 0;
      }
      //alert(leftMenuWidth);
      let rtWrapperWidth = windowWidth - (leftMenuWidth + leftPanelWidth + 60);
      cols = parseInt(rtWrapperWidth / rtMinWidth);
      rtWidth = parseInt(rtWrapperWidth / cols) - 20;
      rtWidth = rtWidth + "px";
      rtWrapperWidth = $("#rtGrid").width();
      //alert(rtWrapperWidth);
      if (rtWrapperWidth) {
        cols = parseInt((rtWrapperWidth - 10) / rtMinWidth);
        rtWidth = parseInt(rtWrapperWidth / cols) - 15;
        rtWidth = rtWidth + "px";
      }
      //alert(rtWrapperWidth);
      //alert(cols);
      //alert(rtWidth);
      $(":root").css("--rt-cols", cols);
      $(":root").css("--rt-col-width", rtWidth);
      //if (vm.drawer) {
      //  $(":root").css("--rt-cols", cols + 1);
      //} else {
      //  $(":root").css("--rt-cols", cols);
      //}

      if (!vm.drawer) {
        if (vm.rtSettings.DisplayLeftPanel) {
          $("#rtListLeft").show();
          $(":root").css("--rt-tab-width", "330px");
        }
        //if (vm.rtSessions.length > 0) {
        //  $(":root").css("--rt-tab-width", "430px");
        //} else {
        //  $(":root").css("--rt-tab-width", "240px");
        //}
      } else {
        $("#rtListLeft").hide();
        $(":root").css("--rt-tab-width", "0px");
      }
    },
    preventHideFilter() {},
    toggleFilter(e) {
      vm.filterDisplayState = !vm.filterDisplayState;
      e.stopPropagation();
    },
    hideFilter() {
      vm.filterDisplayState = false;
    },
    filterByGroup(groupId) {
      vm.filterDisplayState = false;
      vm.rtGroupId = groupId;
    },
    onTextSearch() {
      vm.searchText = vm.searchText.toLowerCase().trim();
    },
    tabClicked(tab, sessionId, rtGroupId, sessionName) {
      //alert(tab);
      //vm.drawerPinned = !vm.drawerPinned;
      if (sessionId) {
        vm.drawerPinned = true;
      } else {
        vm.drawerPinned = false;
      }
      if (vm.drawerPinned && vm.drawer) {
        //vm.drawer = false;
      }
      if (vm.drawerPinned) {
        vm.drawer = false;
      } else {
        vm.drawer = true;
      }
      if (vm.liveSessionCount + vm.upcomingSessionCount < 2) {
        vm.drawer = true;
      }
      if (!vm.rtSettings.ShowSessionList) {
        vm.drawer = true;
      }
      if (!vm.rtLoading) {
        //alert("sessionId");
        vm.rtLoading = true;
        vm.tabId = tab;
        if (tab == 2) {
          vm.sessionId = sessionId ? sessionId : "";
          vm.sessionRTGroupId = rtGroupId ? rtGroupId : "";
          vm.exhibitorId = "";
          vm.exhibitorName = "";
          vm.exhibitorRTGroupId = "";
        } else if (tab == 3) {
          vm.sessionId = "";
          vm.sessionRTGroupId = "";
          vm.exhibitorId = sessionId;
          vm.exhibitorName = sessionName;
          vm.exhibitorRTGroupId = rtGroupId;
        }
        //alert(vm.sessionId);
        //console.log(tab);
        //console.log(sessionId);
        if (tab == 2 && sessionId) {
          router.push(vm.rtPageURL + "/" + sessionId);
        } else if (tab == 3 && sessionId) {
          router.push(
            vm.rtPageURL + "/" + sessionId + "/exhibitor/" + sessionName
          );
        } else {
          router.push(vm.rtPageURL);
        }
        vm.rtGroupId = "";
        vm.searchText = "";
        //setTimeout(() => {
        vm.loadRoundTables();
        //}, 10000);
        setTimeout(() => {
          vm.calculateRTColumlCount();
          setTimeout(() => {
            vm.calculateRTColumlCount();
          }, 1000);
        }, 1000);
      }
    },
    loadSessionSettings() {
      db.collection(vm.event_collectionName)
        .doc("Settings")
        .collection("Sessions")
        .doc("SessionsSettings")
        .get()
        .then((doc) => {
          if (doc.exists) {
            var data = doc.data();
            if (data.AgendaFilterOption != undefined) {
              vm.AgendaFilterOption = parseInt(data.AgendaFilterOption);
            }
            if (data.AllowAddRemoveMyAgenda != undefined) {
              vm.AllowAddRemoveMyAgenda = data.AllowAddRemoveMyAgenda;
            }
          }
          vm.sessionSettingsLoaded = true;
          if (vm.AgendaFilterOption == 0) {
            vm.mySessionsLoaded = true;
          } else {
            vm.loadMySession();
          }
        });
    },
    loadRTSettings() {
      db.collection(vm.event_collectionName)
        .doc("Settings")
        .collection("Roundtable")
        .doc("RoundtableSettings")
        .get()
        .then(function (doc) {
          if (doc.exists) {
            if (doc.data().ShowFilter) {
              vm.rtSettings.ShowFilter = doc.data().ShowFilter;
            }
            if (doc.data().ShowSearch) {
              vm.rtSettings.ShowSearch = doc.data().ShowSearch;
            }
            if (doc.data().HostLegend) {
              vm.rtSettings.HostLegend = doc.data().HostLegend;
            }
            if (doc.data().SeatGrabText) {
              vm.rtSettings.SeatGrabText = doc.data().SeatGrabText;
            }
            if (doc.data().AllowAudienceViewText) {
              vm.rtSettings.AudienceViewText = doc.data().AllowAudienceViewText;
            }
            if (doc.data().TableFullText) {
              vm.rtSettings.TableFullText = doc.data().TableFullText;
            }
            if (doc.data().ShowSessionList == false) {
              vm.rtSettings.ShowSessionList = false;
            }
            if (doc.data().DisplayLeftPanel == false) {
              vm.rtSettings.DisplayLeftPanel = false;
            }
          }
        });
    },
    loadSessionRTGroups() {
      db.collection(vm.event_collectionName)
        .doc("SessionList")
        .collection("Sessions")
        .where("SessionTypeDetails.TypeID", "==", 4)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            let session = doc.data();
            if (
              session.SessionTypeDetails &&
              session.SessionTypeDetails.RoundTableTopic &&
              session.SessionTypeDetails.RoundTableTopic.TopicId
            ) {
              vm.sessionRTGroupIDs.push(
                session.SessionTypeDetails.RoundTableTopic.TopicId
              );
            }
          });

          db.collection(vm.event_collectionName)
            .doc("ExhibitorList")
            .collection("Exhibitors")
            .get()
            .then((querySnapshot) => {
              querySnapshot.forEach((doc) => {
                let data = doc.data();
                if (data.RoundTableTopic && data.RoundTableTopic.TopicId) {
                  vm.sessionRTGroupIDs.push(data.RoundTableTopic.TopicId);
                }
              });
              if ([0, 1].includes(vm.tabId)) {
                vm.loadRoundTables();
              }
              vm.checkOpenAndPrivateTables();
            });

          //if ([0, 1].includes(vm.tabId)) {
          //  vm.loadRoundTables();
          //}
          //vm.checkOpenAndPrivateTables();
        });
    },
    loadMySession() {
      vm.mySessions = [];
      let headers = {
        "content-type": "application/json",
        Authorization: "Bearer " + vm.getSessionToken(),
      };
      let requestData = {
        key: {
          instanceId: "OA_UAT",
          clientId: vm.clientId,
          eventId: vm.eventId,
        },
        data: {
          AttendeeId: vm.uid,
        },
      };
      //bus.$emit("toggleLoader", true);
      axios
        .post(APIs.MyAgenda, requestData, {
          headers: headers,
        })
        .then((responseData) => {
          //bus.$emit("toggleLoader", false);
          if (
            responseData &&
            responseData.data &&
            responseData.data.status == 0 &&
            responseData.data.sessions
          ) {
            responseData.data.sessions.map(function (item) {
              vm.mySessions.push(item.SessionId);
            });
          }
          vm.mySessionsLoaded = true;
        })
        .catch((error) => {
          //vm.rtLoading = false;
          console.log(error);
          vm.mySessionsLoaded = true;
        });
    },
    loadRTSessions() {
      db.collection(vm.event_collectionName)
        .doc("SessionList")
        .collection("Sessions")
        .where("SessionTypeDetails.TypeID", "==", 4)
        .where("IsPublished", "==", true)
        //.where("StartDate", ">", new Date("2020-01-01"))
        .where("EndDate", ">", new Date())
        //.orderBy("StartDate", "asc")
        .orderBy("EndDate", "asc")
        .get()
        .then((querySnapshot) => {
          var currentTime = parseInt(new Date().getTime() / 1000);
          querySnapshot.forEach((doc) => {
            let session = doc.data();
            session.StartTimeStamp = session.StartDate.seconds;
            session.EndTimeStamp = parseInt(session.EndDate.seconds);
            session.StartTimeLabel = common.getFormattedDateTime(
              session.StartTimeStamp
            );
            session.EndTimeLabel = common.getFormattedDateTime(
              session.EndTimeStamp
            );
            session.Status = 0;
            session.StatusLabel = "Past";
            if (
              currentTime >= session.StartTimeStamp &&
              currentTime <= session.EndTimeStamp
            ) {
              vm.liveSessionCount++;
              session.Status = 1;
              session.StatusLabel = "Live";
            } else if (currentTime < session.StartTimeStamp) {
              vm.upcomingSessionCount++;
              session.Status = 2;
              session.StatusLabel = "Upcoming";
            }
            vm.rtSessions.push(session);
            if (
              session.SessionTypeDetails &&
              session.SessionTypeDetails.RoundTableTopic &&
              session.SessionTypeDetails.RoundTableTopic.TopicId
            ) {
              if (vm.sessionId == session.SessionId) {
                vm.sessionRTGroupId =
                  session.SessionTypeDetails.RoundTableTopic.TopicId;
              }
            }
          });
          if (vm.tabId == 2 && vm.sessionId && vm.sessionRTGroupId) {
            vm.loadRoundTables();
            vm.tabClicked(2, vm.sessionId, vm.sessionRTGroupId);
          } else {
            if (vm.tabId == 2 && vm.allRoundTables.length == 0) {
              router.push(vm.rtPageURL);
              location.reload();
            }
          }
          vm.rtSessions = vm.rtSessions.sort(function (a, b) {
            let v1 = a.StartTimeStamp;
            let v2 = b.StartTimeStamp;
            return v1 < v2 ? -1 : v1 > v2 ? 1 : 0;
          });
          vm.sessionsLoaded = true;
          console.log("vm.rtSessions>>>>", vm.rtSessions);
          console.log("vm.sessionRTGroupId>>>>", vm.sessionRTGroupId);
        });
    },
    filterMySession() {
      //alert("filterMySession");
      if (vm.AgendaFilterOption == 1) {
        vm.rtSessions = vm.rtSessions.filter(function (item) {
          return vm.mySessions.includes(item.SessionId);
        });
      }
      vm.mySessionsFiltered = true;
    },
    changeSessionStatusWithTime() {
      var currentTime = parseInt(new Date().getTime() / 1000);
      let currentSessionEnded = false;
      let nextSessionFound = false;
      vm.liveSessionCount = 0;
      vm.upcomingSessionCount = 0;
      vm.rtSessions.forEach((session) => {
        if (
          currentTime >= session.StartTimeStamp &&
          currentTime <= session.EndTimeStamp
        ) {
          vm.liveSessionCount++;
          session.Status = 1;
          session.StatusLabel = "Live";
        } else if (currentTime < session.StartTimeStamp) {
          vm.upcomingSessionCount++;
          session.Status = 2;
          session.StatusLabel = "Upcoming";
        } else if (currentTime > session.EndTimeStamp) {
          session.Status = 0;
          session.StatusLabel = "Past";
          if (session.SessionId == vm.sessionId) {
            currentSessionEnded = true;
          }
        }
      });
      vm.rtSessions = vm.rtSessions.filter(function (session) {
        return session.Status > 0;
      });
      vm.rtSessions.forEach((session) => {
        if (currentSessionEnded && !nextSessionFound) {
          vm.sessionId = session.SessionId;
          vm.sessionRTGroupId =
            session.SessionTypeDetails.RoundTableTopic.TopicId;
          nextSessionFound = true;
        }
      });
      if (currentSessionEnded) {
        if (nextSessionFound) {
          router.push(vm.rtPageURL + "/" + vm.sessionId);
          vm.rtGroupId = "";
          vm.searchText = "";
          vm.loadRoundTables();
        } else {
          router.push(vm.rtPageURL);
          vm.tabClicked(0, "", "");
        }
      }
    },
    loadExhibitors() {
      db.collection(vm.event_collectionName)
        .doc("ExhibitorList")
        .collection("Exhibitors")
        .where("IsPublished", "==", true)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            if (doc.id == vm.exhibitorId) {
              let data = doc.data();
              //(data.MappedRoundTables && data.MappedRoundTables.length > 0) ||
              //debugger;
              if (data.RoundTableTopic && data.RoundTableTopic.TopicId) {
                var exhibitor = Object();
                exhibitor.ExhibitorId = doc.id;
                exhibitor.ExhibitorName = data.Name;
                exhibitor.MappedRoundTables = data.MappedRoundTables;
                exhibitor.RoundTableTopic = data.RoundTableTopic;
                if (vm.exhibitorId == exhibitor.ExhibitorId) {
                  vm.exhibitorRTGroupId = exhibitor.RoundTableTopic.TopicId;
                  vm.exhibitorName = exhibitor.ExhibitorName;

                  //document.getElementById("headerText").innerText =
                  //  vm.headerText + " - " + vm.exhibitorName;
                  //alert(vm.exhibitorName);
                }
                vm.rtExhibitors.push(exhibitor);
              }
            }
          });
          if (vm.tabId == 3 && vm.exhibitorId) {
            vm.loadRoundTables();
            //vm.tabClicked(
            //  3,
            //  vm.rtExhibitors[0].ExhibitorId,
            //  vm.exhibitorRTGroupId,
            //  vm.exhibitorName
            //);
          }
          //else {
          //  if (vm.tabId == 2 && vm.allRoundTables.length == 0) {
          //    router.push(vm.rtPageURL);
          //    location.reload();
          //  }
          //}
          vm.exhibitorsLoaded = true;
        });
    },
    loadRoundTables() {
      //alert("loadRoundTables");
      vm.rtGroups = [{ TopicId: "", TopicName: "All" }];
      vm.disposeRoundTableListener();
      vm.allRoundTables = [];
      let dbRef = db
        .collection(vm.event_collectionName)
        .doc("RoundTableList")
        .collection("RoundTables");
      if (vm.tabId == 0) {
        dbRef = dbRef.where("PreAssigned", "==", false);
      } else if (vm.tabId == 1) {
        dbRef = dbRef.where("PreAssigned", "==", true);
      } else if (vm.tabId == 2 && vm.sessionId && vm.sessionRTGroupId) {
        dbRef = dbRef.where("Topic.TopicId", "==", vm.sessionRTGroupId);
      } else if (vm.tabId == 3 && vm.exhibitorId && vm.exhibitorRTGroupId) {
        //alert(vm.exhibitorRTGroupId);
        dbRef = dbRef.where("Topic.TopicId", "==", vm.exhibitorRTGroupId);
      }
      if (!vm.isAdminComponent) {
        dbRef = dbRef.where("IsPublished", "==", true);
      }
      dbRef
        .get()
        .then((querySnapshot) => {
          //console.log(querySnapshot);
          querySnapshot.forEach((doc) => {
            let table = doc.data();
            table.SpectatorEnabled = false; //Stopped Spectate Mode
            let flag = true;
            if ([0, 1].includes(vm.tabId)) {
              if (
                table.Topic &&
                table.Topic.TopicId &&
                vm.sessionRTGroupIDs.includes(table.Topic.TopicId)
              ) {
                flag = false;
              }
            }
            // if (
            //   table.MapTo &&
            //   table.MapTo.IsMapped &&
            //   table.MapTo.Entity &&
            //   table.MapTo.Entity.Id
            // ) {
            //   flag = false;
            // }
            //if (table.TableId == "99903845") {
            //  alert("aaa");
            //  debugger;
            //}
            var filteredtables = vm.allRoundTables.filter(function (item) {
              return table.TableId == item.TableId;
            });
            if (filteredtables.length > 0) {
              flag = false;
            }
            if (flag) {
              table.Capacity = isNaN(table.Capacity) ? 12 : table.Capacity;
              table.Occupied = isNaN(table.Occupied)
                ? 0
                : table.Occupied < 0
                ? 0
                : table.Occupied;
              table.HostId = "";
              if (table.Host && table.Host.length > 0) {
                table.HostId = table.Host[0].AttendeeId;
                table.HostName = table.Host[0].Name;
              }
              table.CoHostId = "";
              if (table.CoHost) {
                table.CoHostId = table.CoHost.AttendeeId;
              }
              //if (table.TableId == "99903896") {
              //  debugger;
              //}
              table.AttendeeType = 4;
              if (table.HostId == vm.uid) {
                table.AttendeeType = 1;
              } else if (table.CoHostId == vm.uid) {
                table.AttendeeType = 3;
              } else {
                var attendees = table.MappedAttendees.filter(function (
                  attendee
                ) {
                  return attendee.AttendeeId == vm.uid;
                });
                if (attendees.length > 0) {
                  table.AttendeeType = 3;
                }
              }
              if (!table.StreamingClient) {
                table.StreamingClient = "";
              }
              if (table.StreamingClient) {
                table.StreamingClient = table.StreamingClient.trim();
              }
              if (!table.StreamingClientLink) {
                table.StreamingClientLink = "";
              }
              if (table.StreamingClientLink) {
                table.StreamingClientLink = table.StreamingClientLink.trim();
              }
              table.TableType = 1;
              if (table.StreamingClient.toLowerCase() == "zoom") {
                //table.Capacity = 300;
                table.TableType = 0;
              }
              table.MePresent = false;
              table.HostPresent = false;
              //table.CoHostPresent = false;
              table.IsTableFull = false;
              table.JoinButtonLabel = vm.rtSettings.SeatGrabText;
              table.JoinButtonClass = "";
              //if (table.TableId == "2997000") {
              //  debugger;
              //}
              if (
                table.AttendeeType < 4 ||
                !table.PreAssigned ||
                table.SpectatorEnabled
              ) {
                if ([0, 1].includes(vm.tabId)) {
                  let groups = vm.rtGroups.filter(function (group) {
                    return group.TopicId == table.Topic.TopicId;
                  });
                  if (groups.length == 0) {
                    vm.rtGroups.push(table.Topic);
                  }
                }

                table.SessionId = vm.sessionId;
                table.IsStatusChanging = false;
                table.IsDeleting = false;
                vm.allRoundTables.push(table);
              }
            }
          });
          //alert("vm.allRoundTables: " + vm.allRoundTables.length);
          vm.initTableListener();
          //setTimeout(() => {
          //  $('[data-toggle="tooltip"]').tooltip();
          //}, 1000);
          console.log("vm.rtGroups>>>>", vm.rtGroups);
          console.log("vm.allRoundTables>>>>", vm.allRoundTables);

          vm.rtLoading = false;
          setTimeout(() => {
            $('[data-toggle="tooltip"]').tooltip();
          }, 1000);
        })
        .catch(function (error) {
          vm.rtLoading = false;
          console.error("Error : ", error);
        });
    },
    checkOpenAndPrivateTables() {
      var tableRef = db
        .collection(vm.event_collectionName)
        .doc("RoundTableList")
        .collection("RoundTables");
      if (!vm.isAdminComponent) {
        tableRef = tableRef.where("IsPublished", "==", true);
      }
      tableRef
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            let table = doc.data();
            table.SpectatorEnabled = false; //Stopped Spectate Mode
            let flag = true;
            if (
              table.Topic &&
              table.Topic.TopicId &&
              vm.sessionRTGroupIDs.includes(table.Topic.TopicId)
            ) {
              flag = false;
            }
            if (
              table.MapTo &&
              table.MapTo.IsMapped &&
              table.MapTo.Entity &&
              table.MapTo.Entity.Id
            ) {
              flag = false;
            }
            if (flag) {
              table.AttendeeType = 4;
              if (table.Host && table.Host.length > 0) {
                if (table.Host[0].AttendeeId == vm.uid) {
                  table.AttendeeType = 1;
                }
              }
              table.CoHostId = "";
              if (table.CoHost) {
                if (table.CoHost.AttendeeId == vm.uid) {
                  table.AttendeeType = 3;
                }
              }
              if (table.AttendeeType == 4) {
                var attendees = table.MappedAttendees.filter(function (
                  attendee
                ) {
                  return attendee.AttendeeId == vm.uid;
                });
                if (attendees.length > 0) {
                  table.AttendeeType = 3;
                }
              }
              table.TableType = 1;
              if (
                table.AttendeeType < 4 ||
                !table.PreAssigned ||
                table.SpectatorEnabled
              ) {
                if (table.PreAssigned) {
                  vm.privateTableCount++;
                } else {
                  vm.openTableCount++;
                }
              }
            }
          });
          vm.openAndPrivateTablesChecked = true;
        })
        .catch(function (error) {
          console.error("Error : ", error);
        });
    },
    initTableListener: function () {
      vm.allRoundTables.map(function name(table) {
        if (table.StreamingClient.toLowerCase() == "zoom") {
          table.listener = db
            .collection(vm.event_collectionName)
            .doc("RoundTableList")
            .collection("RoundTables")
            .doc(table.TableId)
            .onSnapshot((doc) => {
              var table = doc.data();
              var tables = vm.allRoundTables.filter(function (t) {
                return t.TableId == table.TableId;
              });
              if (tables.length > 0) {
                tables[0].Occupied = table.Occupied;
                if (tables[0].Occupied < tables[0].Capacity) {
                  tables[0].IsTableFull = false;
                  tables[0].JoinButtonLabel = vm.rtSettings.SeatGrabText;
                  tables[0].JoinButtonClass = "";
                } else {
                  tables[0].IsTableFull = true;
                  tables[0].JoinButtonLabel = vm.rtSettings.TableFullText;
                  tables[0].JoinButtonClass = "rt-no-slots";
                }
              }
            });
        } else {
          var col_name =
            "/" +
            vm.event_collectionName +
            "/RoundTableList/RoundTables/" +
            table.TableId +
            "/Participances";
          table.listener = db
            .collection(col_name)
            .onSnapshot((querySnapshot) => {
              var members = [];
              var tableId;
              querySnapshot.forEach((doc) => {
                var participant = doc.data();
                tableId = participant.TableId;
                let attendeeType = 1;
                if (participant.AttendeeType) {
                  attendeeType = participant.AttendeeType;
                }
                if (
                  participant.IsActive &&
                  attendeeType > 0 &&
                  attendeeType < 4
                ) {
                  members.push(participant);
                }
              });
              vm.updateTable(tableId, members);
            });
        }
      });
    },
    updateTable: function (tableId, members) {
      let tables = vm.allRoundTables.filter(function (table) {
        return table.TableId == tableId;
      });
      if (tables.length > 0) {
        //alert("" + tableId);
        let table = tables[0];
        //if (table.TableId == "4124000") {
        //  debugger;
        //}
        table.Occupied = members.length;
        var ids = members.filter(function (member) {
          return member.AttendeeId == table.HostId;
        });
        if (ids.length > 0) {
          table.HostPresent = true;
          //} else if (table.HostId != vm.uid) {
          //  table.Occupied++;
        }
        if (table.Occupied > table.Capacity) {
          table.Occupied = table.Capacity;
        }
        //ids = members.filter(function (member) {
        //  return member.AttendeeId == table.CoHostId;
        //});
        //if (ids.length > 0) {
        //  table.CoHostPresent = true;
        //}
        ids = members.filter(function (member) {
          return member.AttendeeId == vm.uid;
        });
        if (ids.length > 0) {
          table.MePresent = true;
        }
        ids = members.filter(function (member) {
          return (
            member.AttendeeId != table.HostId &&
            //member.AttendeeId != table.CoHostId &&
            member.AttendeeId != vm.uid
          );
        });
        let vacant = table.Capacity;
        if (table.HostId != vm.uid) {
          vacant--;
        }
        //if (table.CoHostId) {
        //  vacant--;
        //}
        vacant -= ids.length;
        table.JoinButtonLabel = vm.rtSettings.SeatGrabText;
        table.JoinButtonClass = "";
        table.IsTableFull = false;
        if (table.HostId == vm.uid) {
          //Join As Host
          //} else if (table.CoHostId == vm.uid) {
          //  //Join As CoHost
        } else if (table.PreAssigned) {
          if (table.AttendeeType == 3) {
            //Join As Speaker
          } else if (table.SpectatorEnabled) {
            //Join As Audience
            table.JoinButtonLabel = vm.rtSettings.AudienceViewText;
            table.JoinButtonClass = "rt-spectate";
          }
        } else if (table.MePresent) {
          //Already Joined
        } else if (vacant > 0) {
          //Join As Speaker
        } else if (table.SpectatorEnabled) {
          //Join As Audience
          table.JoinButtonLabel = vm.rtSettings.AudienceViewText;
          table.JoinButtonClass = "rt-spectate";
          //alert("spectate");
        } else {
          table.IsTableFull = true;
          table.JoinButtonLabel = vm.rtSettings.TableFullText;
          table.JoinButtonClass = "rt-no-slots";
        }
        vm.allRoundTables = vm.allRoundTables.filter(function () {
          return true;
        });
      }
    },

    disposeRoundTableListener() {
      vm.allRoundTables.map(function (item) {
        if (item.listener) {
          item.listener();
        }
        item.listener = null;
      });
      vm.allRoundTables = [];
    },
    OpenAddRTPopup(tableId) {
      vm.$emit("OpenAddRTPopup", tableId);
    },
    changeTableStatus(tableId, isPublished) {
      vm.$emit("changeTableStatus", tableId, isPublished);
    },
    // deleteTable(tableId) {
    //   vm.$emit("deleteTable", tableId);
    // },
    requestConfirmDeleteTable(tableId) {
      vm.selectedTableId = tableId;
      vm.showDeleteConfirmDialog = true;
    },
    onConfirmDeleteTable() {
      vm.showDeleteConfirmDialog = false;
      for (var i = 0; i < vm.allRoundTables.length; i++) {
        if (vm.allRoundTables[i].TableId == vm.selectedTableId) {
          vm.allRoundTables[i].IsDeleting = true;
          vm.$parent.deleteTable(vm.selectedTableId);
          break;
        }
      }
    },
    onDeleteTableSuccess(tableId, success) {
      //bus.$emit("toggleLoader", false);
      var msg = "";
      if (success) {
        msg = "Table Deleted";
        vm.showSnackbar(msg, "info", "top");
        vm.allRoundTables = vm.allRoundTables.filter(function (item) {
          return item.TableId != tableId;
        });
        vm.loadRoundTables();
      } else {
        msg = "Table Not Deleted";
        vm.showSnackbar(msg, "error", "top");
        for (var i = 0; i < vm.allRoundTables.length; i++) {
          if (vm.allRoundTables[i].TableId == tableId) {
            vm.allRoundTables[i].IsDeleting = false;
            break;
          }
        }
      }
    },
    JoinRT(tableId, sessionId) {
      //alert(tableId);
      console.log(sessionId);
      if (!vm.hasValidAuth({ auth_type: 1 })) {
        return;
      }
      vm.tempTable = {
        sessionId: sessionId,
        tableId: tableId,
      };
      //$(".tooltip").tooltip("hide");
      let allowJoin = false;
      let tables = vm.allRoundTables.filter(function name(table) {
        return table.TableId == tableId && !table.IsTableFull;
      });
      if (vm.tabId == 2) {
        let sessions = vm.rtSessions.filter(function (session) {
          return session.SessionId == vm.sessionId && session.Status == 1;
        });
        if (sessions.length > 0) {
          allowJoin = true;
        }
      } else {
        allowJoin = true;
      }
      if (tables.length > 0 && allowJoin) {
        let table = tables[0];
        if (table.StreamingClient.toLowerCase() == "zoom") {
          if (table.Zoom_Detail && table.Zoom_Detail.id) {
            if (vm.uid == table.HostId || vm.uid == table.CoHostId) {
              var hlink =
                table.Zoom_Detail.start_url +
                "&uname=" +
                vm.firstName.trim() +
                "%20" +
                vm.lastName.trim();
              window.open(hlink, "_blank");
              if (sessionId == "") {
                vm.postLeaderboardAction("RTOT");
              } else {
                //vm.postLeaderboardAction("SNVW");
                vm.postLeaderboardAction("RTSN");
              }
            } else {
              if (!vm.RestrictedZoomMeetingEnabled) {
                var link =
                  table.Zoom_Detail.join_url +
                  "&uname=" +
                  vm.firstName.trim() +
                  "%20" +
                  vm.lastName.trim();
                window.open(link, "_blank");
                if (sessionId == "") {
                  vm.postLeaderboardAction("RTOT");
                } else {
                  //vm.postLeaderboardAction("SNVW");
                  vm.postLeaderboardAction("RTSN");
                }
              } else {
                bus.$emit("toggleLoader", true);
                let headers = {
                  Authorization: "Bearer " + vm.getSessionToken(),
                  "content-type": "application/json",
                };
                let requestData = {
                  email: vm.email,
                  name: vm.name,
                  first_name: vm.firstName,
                  last_name: vm.lastName,
                  meetingid: table.Zoom_Detail.id,
                  address: "",
                  phone: vm.phone,
                  industry: "",
                  org: vm.company,
                  job_title: vm.title,
                };
                axios
                  .post(APIs.AddAttendeesToZoom, requestData, {
                    headers: headers,
                  })
                  .then((response) => {
                    if (
                      response &&
                      response.data &&
                      response.data.status == 0 &&
                      response.data.data.id &&
                      response.data.data.join_url &&
                      response.data.data.join_url != ""
                    ) {
                      bus.$emit("toggleLoader", false);
                      window.open(response.data.data.join_url, "_blank");
                      if (sessionId == "") {
                        vm.postLeaderboardAction("RTOT");
                      } else {
                        //vm.postLeaderboardAction("SNVW");
                        vm.postLeaderboardAction("RTSN");
                      }
                    } else {
                      bus.$emit("toggleLoader", false);
                      vm.retryJoinInZoomPopup();
                    }
                  })
                  .catch((error) => {
                    bus.$emit("toggleLoader", false);
                    console.log(error);
                    vm.retryJoinInZoomPopup();
                  });
              }
            }
          } else {
            alert(vm.zoomErrorMsg);
            vm.rtLoading = false;
          }
        } else if (table.StreamingClient.toLowerCase() == "custom") {
          if (vm.tabId == 1) {
            vm.postLeaderboardAction("RTOT");
          } else if (vm.tabId == 2) {
            vm.postLeaderboardAction("RTSN");
          } else if (vm.tabId == 3) {
            vm.postLeaderboardAction("RTEB");
          }
          window.open(table.CustomLink, "_blank");
        } else {
          // if (
          //   screen.width < 767 &&
          //   vm.AgoraPlayerBrowserSupportInMobile == false
          // ) {
          //   router.push("/screeninfo");
          // } else if (
          //   screen.width >= 768 &&
          //   screen.width <= 1024 &&
          //   vm.AgoraPlayerBrowserSupportInIPad == false
          // ) {
          //   router.push("/screeninfo");
          // } else {
          if (vm.tabId == 2) {
            if (sessionId != "") {
              router.push({
                path: vm.LiveStageURL + "/" + sessionId + "/" + table.TableId,
              });
            } else {
              router.push({
                path: vm.LiveStageURL + "/" + table.TableId + "_rt",
              });
            }
          } else if (vm.tabId == 3) {
            router.push({
              path: vm.LiveStageURL + "/" + table.TableId + "_exrt",
            });
          } else {
            router.push({
              path: vm.LiveStageURL + "/" + table.TableId + "_rt",
            });
          }
          //}
        }
      }
    },
    retryJoinInZoomPopup() {
      $("#RetryJoinInZoom").modal(
        {
          backdrop: "static",
        },
        "show"
      );
    },
    cancelRetryJoinInZoom() {
      $("#RetryJoinInZoom").modal("hide");
    },
    retryJoinInZoom() {
      $("#RetryJoinInZoom").modal("hide");
      if (vm.tempTable) {
        vm.JoinRT(vm.tempTable.tableId, vm.tempTable.sessionId);
      }
    },
    getCookie(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
    setCookie(cname, cvalue) {
      document.cookie = cname + "=" + cvalue + ";";
    },
    mob_rlist_search() {
      $("#mob_r_search").css("display", "flex");
      $(".mob_search_button").css("opacity", "0 ");
    },
  },
};
</script>

<style>
.rt-wrap #tabWrap {
  position: relative;
}
.rt-wrap .v-slide-group {
  position: absolute;
}
/*.rt-wrap .pinned .v-slide-group {
  position: unset;
}*/
.rt-wrap .v-slide-group {
  position: absolute;
  background: rgb(255, 255, 255);
  height: 100% !important;
  z-index: 2;
}
.rt-wrap .v-slide-group__wrapper {
  position: relative;
  z-index: 1;
  overflow-y: auto;
  scrollbar-color: #888 #333;
  scrollbar-width: thin;
}
.rt-wrap .v-window.v-item-group.theme--light.v-tabs-items {
  overflow-y: auto;
  scrollbar-color: #888 #333;
  scrollbar-width: thin;
}
.rt-wrap .v-slide-group__wrapper::-webkit-scrollbar,
.rt-wrap .v-window.v-item-group.theme--light.v-tabs-items::-webkit-scrollbar {
  width: 6px;
}

.rt-wrap .v-slide-group__wrapper::-webkit-scrollbar-track,
.rt-wrap
  .v-window.v-item-group.theme--light.v-tabs-items::-webkit-scrollbar-track {
  background: #333;
}

.rt-wrap .v-slide-group__wrapper::-webkit-scrollbar-thumb,
.rt-wrap
  .v-window.v-item-group.theme--light.v-tabs-items::-webkit-scrollbar-thumb {
  background: #888;
}

.rt-wrap .v-slide-group__wrapper::-webkit-scrollbar-thumb:hover,
.rt-wrap
  .v-window.v-item-group.theme--light.v-tabs-items::-webkit-scrollbar-thumb:hover {
  background: #555;
}
/*.rt-wrap .v-window.v-tabs-items {
  margin-left: 27px;
}
.rt-wrap .pinned .v-window.v-tabs-items {
  margin-left: 0px;
}*/
.rt-wrap .v-tabs-bar__content {
  transform: none !important;
}
.rt-wrap .v-tabs-bar__content h3 {
  font-size: 26px;
  color: #000;
  font-weight: 700;
  word-break: break-word;
  text-overflow: ellipsis;
  white-space: pre-line;
}
.rt-wrap .v-tabs-bar__content h4 {
  font-size: 22px;
  color: #000;
  font-weight: 700;
  margin-top: 20px;
}
.rt-wrap .v-tab {
  border: 1px solid #dfdfdf;
  margin-bottom: 10px;
  border-radius: 6px;
  justify-content: flex-start;
  color: #000 !important;
  text-transform: capitalize;
  font-size: 16px;
  max-width: 100%;
}
.rt-wrap .v-tabs--vertical > .v-tabs-bar .v-tabs-slider {
  display: none;
}
.rt-wrap .v-tabs--vertical > .v-tabs-bar .v-tab {
  height: auto;
  width: auto;
  padding: 15px;
  justify-content: flex-start;
  align-items: center;
}
.rt-wrap .v-tabs.v-tabs--vertical.theme--light {
  height: calc(100vh - 110px);
}
.rt-wrap .v-tabs .v-slide-group__wrapper {
  will-change: width;
  width: var(--rt-tab-width);
  transition: width 300ms cubic-bezier(0.2, 0, 0, 1) 0s;
}
.rt-wrap .btn-filter {
  text-transform: capitalize;
  font-weight: 400;
}
.rt-wrap .btn-filter.has-filter .v-btn__content:after {
  content: "";
  position: absolute;
  height: 10px;
  width: 10px;
  background: #ff4500;
  border: 2px solid #ff4500;
  border-radius: 50%;
  right: -13px;
  top: 2px;
}
.rt-wrap .custom-radio label {
  z-index: 9;
}
.rt-wrap .custom-radio .v-list-item--active span.radios {
  background-color: #000;
  border-color: #000;
}
.rt-wrap .custom-radio span.radios {
  display: inline-block;
  width: 18px;
  height: 18px;
  margin: -1px 12px 0 0;
  vertical-align: middle;
  cursor: pointer;
  border-radius: 50%;
  border: 2px solid #d3d6db;
  background-repeat: no-repeat;
  background-position: 50%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.upcoming-single-event {
  text-align: left;
}
.event-status {
  /*display: flex;
  justify-content: flex-start;*/
  align-items: center;
  margin-bottom: 10px;
}
span.green-status {
  padding: 3px 5px;
  background: #62be4f;
  display: inline-block;
  color: #fff;
  font-weight: 400;
  font-size: 12px;
  border-radius: 3px;
  margin-right: 10px;
}
span.orange-status {
  padding: 3px 5px;
  background: #ffa01a;
  display: inline-block;
  color: #fff;
  font-weight: 400;
  font-size: 12px;
  border-radius: 3px;
  margin-right: 10px;
}
.event-status p {
  padding-top: 5px;
  margin-bottom: 0;
  font-size: 11px;
  font-weight: 400;
}
p.event-name {
  margin: 0;
  word-break: break-word !important;
  overflow-wrap: break-word;
  white-space: pre-line;
  line-height: 22px;
}
.rt-wrap .btn-drawer {
  position: absolute;
  top: 15px;
  right: 15px;
  height: 30px;
  width: 30px;
  padding: 2px 2px 2px 3px;
  border: 2px solid transparent;
  /*border-radius: 50%;*/
  /*background: #f00;*/
  z-index: 2;
}
.rt-wrap .btn-drawer:before {
  font-size: 1.2em;
  color: rgb(107, 119, 140);
}
.rt-wrap .btn-drawer.collapse {
  padding: 2px;
  display: inline-block;
}
/*.rt-wrap .btn-drawer:hover {
  border: 2px solid #ccc;
}*/
.rt-wrap .btn-drawer:hover:before {
  color: #1976d2;
}
.rt-wrap .btn-drawer.btn-drawer-pin {
  background: #fff url("../assets/Images/pin-dark.png") no-repeat center center /
    15px;
  box-shadow: 0 0 5px rgb(0 0 0 / 30%);
  border-radius: 50%;
}
.rt-wrap .btn-drawer.btn-drawer-unpin {
  background: #fff url("../assets/Images/unpin-dark.png") no-repeat center
    center / 15px;
  box-shadow: 0 0 5px rgb(0 0 0 / 30%);
  border-radius: 50%;
}
/* .rt-wrap .btn-drawer.right-double-arrow {
  background: #fff url("../assets/Images/right-arrows-couple.svg") no-repeat center center / 15px;
  box-shadow: 0 0 5px rgb(0 0 0 / 30%);
  border-radius: 50%;
 
} */
/*.rt-wrap .v-tab.v-tab--active {
  border-color: #000;
  background: #f2f2f2;
}*/
.rt-wrap .v-tab.rt-tab-active {
  border-color: #000;
  background: #f2f2f2;
}
.right-rt-wrap {
  padding: 20px 30px;
}
.right-rt-wrap .tab-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.right-rt-wrap .v-text-field__details {
  display: none;
}
.search-sec {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  border: 1px solid #dfdfdf;
  border-radius: 4px 0 0 4px;
  padding: 0 10px 0 15px;
  height: 44px;
}
.search-sec
  .theme--light.v-text-field--solo
  > .v-input__control
  > .v-input__slot {
  background: transparent;
}
.right-rt-wrap .tab-head .v-input__slot {
  padding: 0px !important;
  width: 100%;
  box-shadow: none !important;
  margin: 0;
}
:root {
  --rt-cols: 3;
  --rt-col-width: 180px;
  --rt-tab-width: 0px;
}
.rt-grid {
  display: grid;
  grid-gap: 20px;
  grid-template-rows: auto;
  grid-template-columns: repeat(var(--rt-cols), var(--rt-col-width));
}
.tab-head h3 {
  margin: 0;
  font-size: 22px;
}
.rt-wrap .v-text-field.v-text-field--solo .v-input__control {
  min-height: 42px !important;
}

/*.v-tooltip--bottom .v-tooltip__content:before {
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid #000;
  top: -6px;
  left: 50%;
  transform: translate(-50%);
}
.v-tooltip--bottom .v-tooltip__content:before {
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid #000;
  top: -6px;
  left: 50%;
  transform: translate(-50%);
}*/

.rt-wrap .v-tabs .v-item-group:after {
  display: none;
}
/* .rt-wrap .v-tabs.collapsed .v-item-group:after {
    position: absolute;
    content: "";
    height: 25px;
    width: 25px;
    background: #fff url(../assets/Images/right-arrows-couple.svg) no-repeat center center / 12px;
    transform: rotate(0deg);
    right: -13px;
    border-radius: 50%;
    top: 16px;
    z-index: 999;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
    transition: all 0.2s;
    display: block;
} */
.rt-wrap .v-tabs .v-tabs-bar a.unclps-btn {
  right: -12px;
  z-index: 999999999;
  top: 10px;
  display: inline-block;
  height: 24px;
  width: 24px;
  background: #fff url(../assets/Images/right-arrows-couple.svg) no-repeat
    center center / 10px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
  position: absolute;
  border-radius: 50%;
}
.rt-wrap .v-tabs.pinned .v-tabs-bar a.unclps-btn {
  background: rgb(38, 132, 255)
    url(../assets/Images/right-arrows-couple-white.svg) no-repeat center center /
    10px;
  transform: rotate(180deg);
}
/*.rt-wrap :not(.v-tabs.pinned) .v-tabs-bar a.unclps-btn:hover {
  background: rgb(38, 132, 255)
    url(../assets/Images/right-arrows-couple-white.svg) no-repeat center center /
    10px;
}*/
.rt-wrap .v-tabs.collapsed .v-tabs-bar a.unclps-btn:hover {
  background: rgb(38, 132, 255)
    url(../assets/Images/right-arrows-couple-white.svg) no-repeat center center /
    10px;
}
.rt-wrap :not(.v-tabs.collapsed) .v-tabs-bar a.unclps-btn {
  background: rgb(38, 132, 255)
    url(../assets/Images/right-arrows-couple-white.svg) no-repeat center center /
    10px;
  transform: rotate(180deg);
}
.rt-wrap :not(.v-tabs.collapsed) .v-tabs-bar a.unclps-btn:hover {
  background: rgb(38, 132, 255)
    url(../assets/Images/right-arrows-couple-white.svg) no-repeat center center /
    10px;
  transform: rotate(180deg);
}
.rt-wrap .v-tabs .v-tabs-bar {
  padding: 0px;
  box-shadow: 1px 0 2px rgb(0 0 0 / 50%);
  border-radius: 0px;
  position: relative !important;
  background: rgb(244, 245, 247) !important;
  border-radius: 0px;
}
.rt-wrap .v-tabs.collapsed .v-tabs-bar {
  padding: 0;
  box-shadow: 1px 0 2px rgb(0 0 0 / 50%);
  border-radius: 0px;
}
.rt-wrap .v-tabs .v-item-group.new-color:after,
.rt-wrap .v-tabs.collapsed .v-item-group.new-color:after {
  background-color: #82c28e;
}
/*#rtListLeft {
  height: 100%;
}*/
.round-table-filter-tab {
  display: flex;
  justify-content: center;
  align-items: center;
}
.round-table-filter-tab span {
  min-width: 110px;
  display: inline-flex;
  text-align: center;
  background: #ffffff;
  height: 40px;
  color: #000000;
  font-weight: 600;
  font-size: 16px;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  box-shadow: 0 0 16px rgba(0, 0, 0, 0.3);
}
.round-table-filter-tab span:first-child {
  border-radius: 5px 0 0 5px;
}
.round-table-filter-tab span:last-child {
  border-radius: 0px 5px 5px 0px;
  border-right: none !important;
}
.round-table-filter-tab span:nth-child(2) {
  border-left: 1px solid #dfdfdf;
  border-right: 1px solid #dfdfdf;
}
.round-table-filter-tab span.active-tab {
  background: #1a73e8;
  color: #ffffff;
}
.right-rt-wrap.admin-section-wrap {
  padding: 25px 116px;
}
@media only screen and (min-width: 768px) and (max-width: 1024) {
  .rt-wrap {
    height: 100%;
  }
  .rt-wrap #tabWrap {
    height: 100%;
  }
}
@media only screen and (max-width: 767px) {
  .rt-wrap .v-tabs.v-tabs--vertical.theme--light {
    height: inherit;
  }
}
</style>